export const getLanguages = () => ({
  type: "@saga/GET_LANGUAGES",
});
